import Backdrop from '@/components/backdrop';
import Banner from '@/components/banner';
import { Button } from '@/components/button';

import { useCookiePolicy } from './useCookiePolicy';
import CookieContent from './cookie-content';

interface CookiePolicyProps {
  isCookieConsent: true | undefined;
  isPosthogIdentify: true | false | undefined;
}

const CookiePolicy: React.FC<CookiePolicyProps> = ({ isCookieConsent, isPosthogIdentify }: CookiePolicyProps) => {
  const { isCookieConsentAllowed, isPosthogIdentifyAllowed, handleAllowFromFirstWindow, handleAllowFromSecondWindow, handleNotAllow } =
    useCookiePolicy(isCookieConsent, isPosthogIdentify);

  return (
    <Backdrop isOpen={!isCookieConsentAllowed || isPosthogIdentifyAllowed === undefined} isChildrenBottomLeft={true}>
      <Banner
        isOpen={!isCookieConsentAllowed || isPosthogIdentifyAllowed === undefined}
        isDisableCloseIcon={true}
        isCookiePrivacy={true}
        close={close}
      >
        <div className='flex flex-col gap-4'>
          <div className='flex flex-col gap-2'>
            <div className='flex items-center'>
              <p className='text-[22px] lg:text-2xl text-text-primary text-bold tracking-2pct'>We use cookies 🍪</p>
            </div>
            <CookieContent isCookieConsentAllowed={isCookieConsentAllowed} />
          </div>
          <div className='flex flex-row items-center gap-8'>
            <Button variant='secondary' size='large' onClick={handleNotAllow}>
              Don&apos;t allow
            </Button>
            <Button size='large' onClick={isCookieConsentAllowed === false ? handleAllowFromSecondWindow : handleAllowFromFirstWindow}>
              Allow
            </Button>
          </div>
        </div>
      </Banner>
    </Backdrop>
  );
};

export default CookiePolicy;
